// AudioOverlay — Phase 2 / Step C-3.3 Pass 1 shim. See
// shared/widgets/scenario_os/AudioOverlay.jsx for the canonical
// implementation. Defaults to mode="docked" to preserve original
// learner-app behaviour (position: fixed bottom-right).
import React from 'react';
import AudioOverlayShared from '../../../../shared/widgets/scenario_os/AudioOverlay.jsx';

export default function AudioOverlay(props) {
  return <AudioOverlayShared mode="docked" {...props} />;
}
